module.exports = __webpack_public_path__ + "static/background-2-e698ce6b1cae592184c28e843f4a9d72.png";